export default __webpack_public_path__ + "static/media/home1.b5fc2527.jpg";